import * as Papa from "papaparse";
import {downloadFile} from "./function-util";

const CsvMimeType = 'text/csv;charset=utf-8;'
const CsvFilenameDefault = 'untitled.csv';
const CsvExportDefaults = {
    quotes: false, //or array of booleans
    quoteChar: '"',
    escapeChar: '"',
    delimiter: ",",
    header: true,
    newline: "\r\n",
    skipEmptyLines: false, //other option is 'greedy', meaning skip delimiters, quotes, and whitespace.
    columns: null //or array of strings
}

export async function exportDataToCsv(
    contentBuilder: () => Promise<{ headers: any[], data: any[] }>,
    filenameBuilder:  () => Promise<string>,
    exportOptions?: any
) {
    const content = typeof contentBuilder === 'function' ? await contentBuilder() : null;
    const filename = typeof filenameBuilder === 'function' ? await filenameBuilder(): null;

    if(!content) {
        throw new Error('No content')
    }

    const {headers, data} = content;
    const hasHeaders = Array.isArray(headers) && headers.length > 0;

    const csvData = Papa.unparse({
        fields: headers,
        data: data
    }, {
        ...CsvExportDefaults,
        ...(exportOptions ?? {}),
        header: hasHeaders
    });

    let targetFilename = filename ?? CsvFilenameDefault;

    if (targetFilename.toLowerCase().indexOf('.csv') < 0)
        targetFilename += '.csv';

    downloadFile(csvData, targetFilename, CsvMimeType);
}
